export const cpfCnpjMask = (value: string): string => {
  const cleanValue = value.toUpperCase().replace(/[^A-Z0-9]/g, '');

  if (cleanValue.length <= 11) {
    const numericValue = cleanValue.replace(/[^0-9]/g, '');
    return numericValue.replace(/(\d{3})(\d{3})?(\d{3})?(\d{0,2})/, (_, p1, p2, p3, p4) => {
      let mask = p1;
      if (p2) mask += `.${p2}`;
      if (p3) mask += `.${p3}`;
      if (p4) mask += `-${p4}`;
      return mask;
    });
  } else if (cleanValue.length > 11 && cleanValue.length <= 14) {
    return cleanValue.replace(/([A-Z0-9]{2})([A-Z0-9]{3})?([A-Z0-9]{3})?([A-Z0-9]{4})?([A-Z0-9]{2})/, (_, p1, p2, p3, p4, p5) => {
      let mask = p1;
      if (p2) mask += `.${p2}`;
      if (p3) mask += `.${p3}`;
      if (p4) mask += `/${p4}`;
      if (p5) mask += `-${p5}`;
      return mask;
    });
  }
  return cleanValue;
};